const stringToRGB = (s: string): string => {
  // We need to keep it for backward compatibility
  const hashCode = (str: string) => {
    // java String#hashCode
    let hash = 0;
    for (let i = 0; i < str.length; i += 1) {
      const character = str.charCodeAt(i);
      hash = (hash << 5) - hash + character;
      hash = hash & hash;
    }

    return hash;
  };
  const code = hashCode(s);
  let color = '#';
  for (let i = 0; i < 3; i += 1) {
    color += `00${((code >> (i * 8)) & 0xff).toString(16)}`.substr(-2);
  }

  return color;
};

export default stringToRGB;
